import clsx from "clsx";
import { FC } from "react";

import { PIC } from "@ryde/assets";
import { isLiveMapFullDisplayMode, LiveMapDisplayModeEnum } from "@ryde/shared";

interface ILiveMapDisplayModePreview {
  mode: LiveMapDisplayModeEnum;
}

export const LiveMapDisplayModePreview: FC<ILiveMapDisplayModePreview> = ({
  mode,
}) => {
  const isFull = isLiveMapFullDisplayMode(mode);

  return (
    <div className="live-map-display-mode-preview" aria-hidden>
      <PIC.MapModeSVG
        className={clsx(
          "live-map-display-mode-preview__image",
          isFull
            ? "live-map-display-mode-icon--active"
            : "live-map-display-mode-icon--muted",
        )}
      />
    </div>
  );
};
